import { createRouter, createWebHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'
import BugManagement from '../components/BugManagement.vue'
import AuthManagement from '../components/AuthManagement.vue' // 导入授权管理页面
import UserLoginInfo from '../components/UserLoginInfo.vue'
import Login from '../components/Login.vue'
import HomePage from '../components/HomePage.vue'
import Welcome from '../components/Welcome.vue'
import RegisterPage from '../components/RegisterPage.vue'
import Features from '../components/Features.vue'
import PricingPage from '../components/PricingPage.vue'
import InterestedUsersManagement from '../components/InterestedUsersManagement.vue'
import authApi from '../js/connect.js'
import { syncThemeForRoute } from '../js/adminTheme'

const routes = [
   // 可能还需要一个重定向路由
  { path: '/', name: 'HomePage', component: HomePage },
  { path: '/login', name: 'Login', component: Login },
  { path: '/features', name: 'Features', component: Features },
  { path: '/register', name: 'Register', component: RegisterPage },
  { path: '/dashboard', name: 'Dashboard', component: DashboardView, children: [
    { path: '/welcome', name: 'Welcome', component: Welcome },
    { path: '/auth-management', name: 'AuthManagement', component: AuthManagement },
    { path: '/bug-management', name: 'BugManagement', component: BugManagement },
    { path: '/user-login-info', name: 'UserLoginInfo', component: UserLoginInfo },
    { path: '/interested-users', name: 'InterestedUsersManagement', component: InterestedUsersManagement }
  ] },
  { path: '/pricing', name: 'Pricing', component: PricingPage },
];

const notlogin = ['/', '/login', '/register', '/features', '/pricing']

// 解析JWT token并检查是否过期
function isTokenValid(token) {
  if (!token) {
    return false;
  }
  
  try {
    // JWT token格式: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      return false;
    }
    
    // 解码payload（base64解码）
    const payload = JSON.parse(atob(parts[1]));
    
    // 检查exp字段（过期时间，Unix时间戳）
    if (payload.exp) {
      const currentTime = Math.floor(Date.now() / 1000);
      // 如果当前时间大于过期时间，token已过期
      if (currentTime >= payload.exp) {
        return false;
      }
    }
    
    return true;
  } catch (error) {
    console.error('Token解析失败:', error);
    return false;
  }
}

// 清除登录状态
function clearLoginState() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user_info');
  localStorage.removeItem('isLogin');
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  // 如果是不需要登录的页面，直接放行
  if (notlogin.includes(to.path)) {
    next();
    return;
  }
  
  // 检查登录状态
  const isLogin = localStorage.getItem('isLogin') === 'true';
  const accessToken = localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');
  
  // 如果没有登录标志或token，跳转到登录页
  if (!isLogin || !accessToken) {
    clearLoginState();
    next('/login');
    return;
  }
  
  // 验证access token是否有效
  if (isTokenValid(accessToken)) {
    // token有效，允许访问
    next();
    return;
  }
  
  // access token已过期，尝试刷新
  if (refreshToken) {
    try {
      const response = await authApi.refreshToken(refreshToken);
      // 刷新成功，更新access token
      localStorage.setItem('access_token', response.data.access_token);
      next();
      return;
    } catch (error) {
      // 刷新失败，清除登录状态并跳转到登录页
      console.error('Token刷新失败:', error);
      clearLoginState();
      next('/login');
      return;
    }
  } else {
    // 没有refresh token，清除登录状态并跳转到登录页
    clearLoginState();
    next('/login');
    return;
  }
});

router.afterEach((to) => {
  syncThemeForRoute(to.path);
});

export default router
